// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607231026/js/" + chunkId + "." + {"44":"001e95cf","225":"b36a06e4","481":"07525c52","486":"2c7a3a1e","770":"53619a45"}[chunkId] + ".0.9048589243042147.chunk.js";
};